"use client";

import Image from "next/image";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type AuthShellProps = {
	children: ReactNode;
	title: string;
	subtitle: string;
	className?: string;
};

export function AuthShell({ children, title, subtitle, className }: AuthShellProps) {
	return (
		<div className="min-h-[calc(100vh-62px)] bg-slate-50 px-4 py-8 text-slate-950 sm:px-6">
			<div className="mx-auto flex min-h-[calc(100vh-126px)] w-full max-w-[430px] items-center justify-center">
				<section className={cn("w-full", className)}>
					<div className="w-full rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
						<div className="mb-6 text-center">
							<Image
								src="/StudyStash - Logo_Colour - RGB.png"
								alt="StudyStash"
								width={176}
								height={38}
								className="mx-auto h-7 w-auto object-contain"
								priority
							/>
							<h2 className="mt-6 text-2xl font-semibold tracking-normal text-slate-950">{title}</h2>
							<p className="mt-2 text-sm leading-6 text-slate-600">{subtitle}</p>
						</div>
						{children}
					</div>
				</section>
			</div>
		</div>
	);
}
